
const beforeEachHandler = () => {
    return true
}

export default beforeEachHandler